<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Payment ID" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <!-- <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                      -->
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_LOG }"><a @click="onClickTabLog()" href="#tab_2" data-toggle="tab" aria-expanded="true">Log</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProjectName" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProjectName" placeholder="" v-model="formData.project_name">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLocation" class="col-sm-4 control-label">Location</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputLocation" placeholder="" v-model="formData.location">
                              </div>                     
                            </div>                      
                          </div>
                        </div>                       
                      </div>
                    </div>                   
                    <div v-bind:class="{ active: tabActive == TAB_LOG }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                          <label for="recordPerPageLog" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                          <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                            <select v-on:change="changePageSizeLog" ref="recordPerPageLog" class="form-control">
                              <option v-if="inquiryParamLog.pageSize == 5" selected>5</option><option v-else>5</option>
                              <option v-if="inquiryParamLog.pageSize == 10" selected>10</option><option v-else>10</option>
                              <option v-if="inquiryParamLog.pageSize == 20" selected>20</option><option v-else>20</option>
                              <option v-if="inquiryParamLog.pageSize == 50" selected>50</option><option v-else>50</option>
                              <option v-if="inquiryParamLog.pageSize == 100" selected>100</option><option v-else>100</option>
                            </select>
                          </div>                           
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:center;">Gate ID</th>
                                <th style="text-align:center;">Process Date</th>
                                <th style="text-align:center;">Status</th>
                                <th style="text-align:left;">Message</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listLog" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceLog + i + 1}}</td>
                                <td style="text-align:center;" nowrap>{{ row.gate_id }}</td>
                                <td style="text-align:center;">{{ row.process_date }}</td>
                                <td style="text-align:center;">{{ row.status }}</td>
                                <td style="text-align:left;">{{ row.message }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.pass_code }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                          <div class="form-group">
                            <label style="width:25px;text-align:right;">
                                <a href="#"><i v-on:click="changePageLog(1)" class="icon ion-ios-rewind"></i></a>
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i v-on:click="changePageLog(inquiryParamLog.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                            </label>
                            <label>
                                Page
                            </label>
                            <label>
                                <input v-model="inquiryParamLog.CurrentPageNumber" v-on:keyup.enter="gotoPageLog($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                            </label>
                            <label id="TotalPageText">
                              {{ totalPagesLog }}                
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i v-on:click="changePageLog(inquiryParamLog.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                            </label>
                            <label style="width:25px;text-align:left;">
                                <a href="#"><i v-on:click="changePageLog(totalPagesLog)" class="icon ion-ios-fastforward"></i></a>
                            </label>
                          </div>
                        </div>                        
                      </div>
                    </div> 
                  </div>
                </div>
              </div>  
              <input type="hidden" class="form-control" v-model="formData.id">                                                                   
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_OVERVIEW = 'tabOverview'
const TAB_LOG = 'tabLog'

export default {
  name: 'GateForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_LOG: TAB_LOG,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        location: '',
        project_id: 0
      },
      listLog: null,
      startSequenceLog: 0,
      totalRowsLog: 0,
      totalPagesLog: 0,
      inquiryParamLog: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'process_date'
      },
      tabActive: '',
      originalcallback: '',
      prevRoute: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.clearing = this.$route.params.clearingStatus
    this.getDetail(this.clearing)
  },
  mounted() {
  },
  methods: {
    getDetail(clearingStatus) {
      let baseUrl = config.environment === 'Local' ? '/api/Gate/' : '/api/Gate/' + this.$store.state.userInfo.projects[0] + '/'
      api
        .request('Gate', 'get', baseUrl + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabLog() {
      this.inquiryLog()
    },
    inquiryLog() {
      this.inquiryParamLog.WhereClause = 'gate_id = \'' + this.formData.id + '\''
      let baseUrl = config.environment === 'Local' ? '/api/Gate/' : '/api/Gate/' + this.$store.state.userInfo.projects[0] + '/'
      api
        .request('Gate', 'get', baseUrl + this.formData.id + '/Log?WhereClause=' + this.inquiryParamLog.WhereClause +
                                 '&PageSize=' + this.inquiryParamLog.PageSize + '&CurrentPageNumber=' + this.inquiryParamLog.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParamLog.SortDirection + '&SortExpression=' + this.inquiryParamLog.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listLog = data.entity
          this.totalRowsLog = data.totalRows
          this.totalPagesLog = data.totalPages
          this.$refs.recordPerPageLog.value = this.inquiryParamLog.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    },
    changePageSizeLog(evt) {
      this.inquiryParamLog.PageSize = evt.target.value
      this.inquiryParamLog.CurrentPageNumber = 1
      this.startSequenceLog = (this.inquiryParamLog.CurrentPageNumber - 1) * this.inquiryParamLog.PageSize
      this.inquiryLog()
    },
    gotoPageLog(evt) {
      if (evt.target.value > this.totalPagesLog) {
        this.inquiryParamLog.CurrentPageNumber = this.totalPagesLog
      } else if (evt.target.value < 1) {
        this.inquiryParamLog.CurrentPageNumber = 1
      }
      this.startSequenceLog = (this.inquiryParamLog.CurrentPageNumber - 1) * this.inquiryParamLog.PageSize
      this.inquiryLog()
    },
    changePageLog(page) {
      if (page < 1) {
        this.inquiryParamLog.CurrentPageNumber = 1
      } else if (page > this.totalPagesLog) {
        this.inquiryParamLog.CurrentPageNumber = this.totalPagesLog
      } else {
        this.inquiryParamLog.CurrentPageNumber = page
      }
      this.startSequenceLog = (this.inquiryParamLog.CurrentPageNumber - 1) * this.inquiryParamLog.PageSize
      this.inquiryLog()
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// GateForm.vue?23ceaeab